module.exports = __webpack_public_path__ + "static/work68-49407f26c4f8c064f17c6ab4d616c230.jpg";